// A button that opens a menu of options
import { Button, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";

interface ButtonMenuItemBase {
  id?: string;
  name: string;
}

interface ButtonMenuProps<T extends ButtonMenuItemBase> {
  buttonLabel: string;
  startIcon?: React.ReactNode;
  menuItems: Array<T>;
  onSelect?: (item: T) => void;
  disabled?: boolean;
  variant?: "text" | "outlined" | "contained";
}

export default function ButtonMenu<T extends ButtonMenuItemBase>(props: ButtonMenuProps<T>) {
  const [menuAnchor, setMenuAchor] = useState<null | HTMLElement>(null);

  return (
    <>
      <Button
        disabled={props.disabled}
        startIcon={props.startIcon}
        onClick={(event) => setMenuAchor(event.currentTarget)}
        variant={props.variant}
      >
        {props.buttonLabel}
      </Button>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAchor(null)}
      >
        {props.menuItems.map((item: T, idx: number) => (
          <MenuItem
            key={`${item.id || item.name}-${idx}`}
            onClick={() => {
              if (props.onSelect) {
                props.onSelect(item);
              }
              setMenuAchor(null);
            }}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}